import { render } from "./ChatHistoryList.vue?vue&type=template&id=00145d37&scoped=true&ts=true"
import script from "./ChatHistoryList.vue?vue&type=script&lang=ts"
export * from "./ChatHistoryList.vue?vue&type=script&lang=ts"

import "./ChatHistoryList.vue?vue&type=style&index=0&id=00145d37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00145d37"]])

export default __exports__